import React from 'react'
import styled, { keyframes } from 'styled-components'
import { useTranslation } from 'react-i18next'

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.background.secondary};
  gap: ${({ theme }) => theme.spacing.large};
`

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid ${({ theme }) => theme.colors.border.default};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

const LoadingText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  animation: ${pulse} 1.5s ease-in-out infinite;
`

const Skeleton = styled.div`
  width: 100%;
  max-width: 800px;
  height: 60%;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  animation: ${pulse} 1.5s ease-in-out infinite;
`

export const PDFLoadingState: React.FC = () => {
  const { t } = useTranslation('ui')

  return (
    <LoadingContainer>
      <Spinner />
      <LoadingText>{t('pdfViewer.loading.text')}</LoadingText>
      <Skeleton />
    </LoadingContainer>
  )
}
